export default {
  googleMapApiKey: "AIzaSyDwZP87MovRIe8pKZtoOn9DZvXrQakR3F0",
  googleMeasurementId: "GTM-TZ6PSVXJ"
}
